export default "__VITE_ASSET__dJtAEo4I__"